module.exports = __webpack_public_path__ + "static/media/2.c7e9db02.jpg";